<template>
  <div class="agent">
      <div class="agentWrapper">
          <div><el-button size="mini" type="primary" @click="backTo">{{$t('other.a605')}}</el-button></div>
          <div class="views" >{{$t('other.a2800')}}</div>
          <div class="awrapper">
              <div class="noog">
                <div class="imgBox">
                    <img :src="groupInfo.image" alt="">
                </div>
                <div class="uolp">
                    <div v-if="!isEditor" class="groupName">{{groupInfo.groupName}} <i class="el-icon-edit" @click="isEditor=true"></i></div>
                    <div v-else>
                        <el-input v-show="isEditor" style="width:380px;margin-right:20px;margin-bottom:20px" v-model="groupInfo.groupName"></el-input>
                        <el-button v-show="isEditor"  type="primary" @click="updataGroupName">{{$t('other.a274')}}</el-button>
                        <el-button v-show="isEditor"  type="info" @click="isEditor=false">{{$t('other.a106')}}</el-button>
                    </div>
                    <div class="bhyti">
                        <div class="yimg"><span class="onkg">{{$t('other.a659')}}：</span><span class="onpk">{{groupInfo.itemSku}}</span></div>
                        <div class="yimg"><span class="onkg">{{$t('other.a660')}}：</span><span class="onpk">{{groupInfo.storeItems.length}}</span></div>
                        <div class="yimg"><span class="onkg">{{$t('other.a2801')}}：</span><span class="onpk">{{groupInfo.totalStoreNum}}</span></div>
                    </div>
                </div>
              </div>
              <div class="oknd">
                  <div :class="{'yund':true, 'active':ActiveType}" @click="navClick">
                      <div class="yitn">
                          <img src="../../../assets/img/agent.png" />
                      </div>
                      <div>
                          <div class="inlng">{{groupInfo.limitAgencyNum==-1?$t('other.a2803'):groupInfo.limitAgencyNum}}</div>
                          <div class="onirg">{{$t('other.a2802')}}</div>
                      </div>
                  </div>
                  <div :class="{'yund':true, 'active':type == 2}" @click="chooseItem(2)">
                      <div class="yitn">
                          <img src="../../../assets/img/orders.png" />
                      </div>
                      <div>
                          <div class="inlng">{{$t('other.a2804')}}：{{groupInfo.storeItems.length}}</div>
                          <div class="onirg">{{$t('other.a2805')}}</div>
                      </div>
                  </div>
                  <div :class="{'yund':true, 'active':type == 3}" @click="chooseItem(3)">
                      <div class="yitn">
                          <img src="../../../assets/img/agent.png" />
                      </div>
                      <div>
                          <div class="inlng">{{agentNum}}</div>
                          <div class="onirg">{{$t('other.a2806')}}</div>
                      </div>
                  </div>
                  <!-- <div :class="{'yund':true, 'active':type == 1}"  @click="chooseItem(1)">
                      <div class="yitn">
                          <img src="../../../assets/img/warning.png" />
                      </div>
                      <div>
                          <div class="inlng">0</div>
                          <div class="onirg">分销营收</div>
                      </div>
                  </div> -->
                  
                  
              </div>
          </div>
      </div>

      <router-view :groupInfo="groupInfo" :ActiveType="ActiveType"> </router-view>



 
  </div>
</template>

<script>
import { getGruopAndTempInfo} from '../../../utils/toolFun'
import api from '../../../api/api'
import groupApi from '../../../api/moudles/userStoreItems'
export default {
data(){
return{
    groupInfo:{
        image:null,
        totalStoreNum:0,
        storeItems:[{
            agentList:[]
        }],
    },
    type:2,
    ActiveType:false,
    isEditor:false,
    agentNum:0,
    agenList:[],
    orderList:[],
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    value:null,
    agentInfo:null,
}
},
created(){
    getGruopAndTempInfo({
        groupId:this.$route.query.groupId,
        productId:this.$route.query.productId,
    }).then(res => {
        this.groupInfo=res.groupInfo
        this.groupInfo.totalStoreNum=0
        this.groupInfo.storeItems.forEach(p => {
            p.lowestDistributePrice=p.lowestDistributePrice ? p.lowestDistributePrice : 0
            p.agentList=[]
            this.groupInfo.totalStoreNum+=p.storeNum
            
        })
        this.getData()

        
    })

    
    
},
methods:{
    backTo(){
      this.$router.push({
          path:'/myselfproduct/goods',
          query:{
              groupId:this.$route.query.groupId,
              type:this.$route.query.type
          }
      })
    },

    updataGroupName(){
        groupApi
        .updateGroup(this.groupInfo)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a2730'))
        this.isEditor=false
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    navClick(){
        if(this.type!=2){
            this.ActiveType = !this.ActiveType
        }
    },
    chooseItem(num){
        console.log(num);
        this.type=num
        if(num == 2){
            this.ActiveType = false
            this.$router.push({
                path:'/agent/hasAgentDetail',
                query:{
                    productId:this.$route.query.productId,
                    groupId:this.$route.query.groupId,
                    type:this.$route.query.type,
                }
            })
        }

        if(num == 3){
            this.$router.push({
                path:'/agent/agents',
                query:{
                    productId:this.$route.query.productId,
                    groupId:this.$route.query.groupId,
                    type:this.$route.query.type,
                }
            })
        }

        if(num == 1){
            this.$router.push({
                path:'/agent/priceControl',
                query:{
                    productId:this.$route.query.productId,
                    groupId:this.$route.query.groupId,
                    type:this.$route.query.type,
                }
            })
        }
    },

    getOrderList(){
        let list=this.agentInfo[this.value]
        this.orderList=list[0].storeItems
        this.orderList.forEach(p => {
            p.country=list[0].country
        })
        console.log('list',list);
    },

    getData(){
        api
        .getAgencyProductInfo({
            groupId:this.$route.query.groupId,
            userId:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
            console.log('----')
            console.log(res.data)
            console.log(Object.keys(res.data.itemGroups).length)
        this.agentNum=Object.keys(res.data.itemGroups).length
        this.agentInfo=res.data.itemGroups
        let obj=res.data.itemGroups
            console.log(obj)
        for(let key in obj){
            obj[key][0].storeItems.forEach(p => {
                p.children=p.children ? p.children : []
                if(p.children.length > 0){
                    p.cusCode_P=p.children[0].cusCode
                }
                p.country=obj[key][0].country
            })
            this.agenList.push(...obj[key][0].storeItems)
        }
        let newObj={}
        this.agenList.forEach(i => {
            i.priceList=[]
            if(i.items.instanceof= Array){
                i.priceList=i.items.map(k => {
                    return k.price
                })
            }
            console.log(i.items)
            if(!newObj[i.cusCode_P]){
                newObj[i.cusCode_P]=[]
                newObj[i.cusCode_P].push(i)

            }else{
                newObj[i.cusCode_P].push(i)
            }
        })

        this.groupInfo.storeItems.forEach(p =>{
            p.agentList=newObj[p.cusCode]
        })

     

        console.log('newObj',newObj)
        console.log('567',this.groupInfo.storeItems);
        console.log('agenList',this.agenList)
        
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    backTo(){
      this.$router.push({
          path:'/myselfproduct/goods',
          query:{
              groupId:this.$route.query.groupId,
              type:this.$route.query.type
          }
      })
    },

}
}

</script>
<style lang="scss" scoped>
@import "../../../assets/scss/mixins";
.agent{

    background-color: #eee;

    .el-icon-edit{
        margin-left: 10px;
        color: #409EFF;
        cursor: pointer;
    }

    .agentWrapper{
        margin: 10px;
        box-sizing: border-box;
        padding: 10px;
        background-color: #fff;
    }

    .tableArea{
        box-sizing: border-box;
        margin: 10px 0 0 0;
        padding: 10px;

        .inln{
            @include flex-start();
            font-weight: 700;
            font-size: 14px;
            color: rgba(0,0,0,.85);
        }

        .tip{
            display: inline-block;
            margin: 0 5px 0 0;
        }

        .tip::after{
            content: "";
            display: inline-block;
            width: 4px;
            height: 14px;
            background-color: #007bfc;
        }

        
    }

    .views{
        font-size: 20px;
        font-weight: 600;
        padding: 10px 0;
        color: rgba(0,0,0,.65);
    }

    .awrapper{
        display: flex;
        justify-content: space-between;

        .oknd{
            flex: 1;
            display: flex;
            justify-content: flex-end;

            .active{
                background-color: #e77f67!important;
                color: #fff;
            }
            .active::after{
                position: absolute;
                content: "";
                width: 100%;
                height: 4px;
                bottom: 0;
                left: 0;
                background-color: #409EFF;
                border-radius: 50px;
            }

            .yund{
                position: relative;
                border-radius: 5px 5px 0 0;
                width: 30%;
                height: 150px;
                background-color: #fafafa;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding-left: 20px;
                cursor: pointer;
                margin-right: 20px;

                .inlng{
                    font-size: 20px;
                    font-weight: 600;
                    padding-bottom: 5px;

                }

                .onirg{
                    font-size: 14px;
                }

                .yitn{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 18px;

                    
                    img{
                        width: 70%;
                    }
                }

                .yitn:nth-child(1){
                    background-color: #ccedff;
                   
                }

                .yitn:nth-child(2){
                    background-color: #fff3d7;
                   
                }
            }
            
        }

        .noog{
            display: flex;
            justify-content: flex-start;
        }

        .uolp{
            width: 350px;
            box-sizing: border-box;
            padding:0 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .bhyti{
                margin: 10px 0 0 0;
                color: rgba(0,0,0,.45);
            }

            .yimg{
                display: flex;
                align-content: center;
                padding: 3px 0;
                font-size: 15px;
                font-weight: 600;
            }

            .onkg{
                display: inline-block;
                width: 91px;
                text-align: right;
            }

            .onpk{
                display: inline-block;
                width: 115px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .groupName{
                font-size: 16px;
                font-weight: bold;
                color: #757575;
                @include multiline-ellipsis(3)
            }
        }

        .imgBox{
            width: 150px;
            height: 150px;
            overflow: hidden;

            img{
                width: 100%;
            }
        }
    }
}
</style>